/**
 * Header Element Renderer
 */

import { BaseElementRenderer, type ElementRenderContext } from './base-element-renderer';

export class HeaderRenderer extends BaseElementRenderer {
  canRender(elementType: string): boolean {
    return elementType === 'header';
  }
  
  render(context: ElementRenderContext) {
    return this.renderEditableText(context, context.element.content || '', 'Kopfzeile eingeben...');
  }
}
